// MySvgButtonPlus.jsx
import React from "react";
import "./mySvgButtonPlus.scss";

const MySvgButtonPlus = ({
  onClickDo,
  withBox = false,         // false = subtle/ghost (good next to Select), true = blue/primary
  ariaLabel = "Create new",
  size = 36,               // match your Select height
  disabled = false,
  title = "Create new",
}) => {
  return (
    <button
      type="button"
      className={`btn-plus ${withBox ? "btn-plus--boxed" : "btn-plus--ghost"}`}
      style={{ "--btn-size": `${size}px` }}
      onClick={onClickDo}
      aria-label={ariaLabel}
      title={title}
      disabled={disabled}
    >
      <svg
        className="btn-plus__icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 256 256"
        role="img"
        aria-hidden="true"
      >
        {/* Keep paths, but let them inherit color */}
        <path fill="none" d="M0 0h256v256H0z" />
        <path
          fill="currentColor"
          d="M128 28C72.77 28 28 72.77 28 128s44.77 100 100 100 100-44.77 100-100S183.23 28 128 28Zm40 104h-32v32h-16v-32H88v-16h32V84h16v32h32Z"
        />
      </svg>
    </button>
  );
};

export default MySvgButtonPlus;
